import { queryOptions } from '@tanstack/react-query';
import { listApartmentPhotos } from '@/api/generated/sdk.gen';
import type { ApartmentPhoto } from '@/api/generated/types.gen';
import { env } from '@/lib/env';

export type { ApartmentPhoto };

export const apartmentPhotosQuery = (apartmentID: string) =>
  queryOptions({
    queryKey: ['apartments', apartmentID, 'photos'],
    queryFn: async ({ signal }) => {
      const res = await listApartmentPhotos({
        throwOnError: true,
        signal,
        path: { id: apartmentID },
      });
      return res.data.items;
    },
    retry: (failureCount, err) => {
      const status = (err as { status?: number })?.status;
      return status !== 401 && status !== 404 && failureCount < 1;
    },
    staleTime: 30_000,
  });

// publicURL prefixes the R2 key with the configured public base. Returns ''
// when VITE_R2_PUBLIC_BASE is unset (local dev) — caller renders a placeholder
// instead of trying to load a broken image.
export function photoPublicURL(p: Pick<ApartmentPhoto, 'r2_key'>): string {
  if (!env.r2PublicBase) return '';
  return `${env.r2PublicBase.replace(/\/$/, '')}/${p.r2_key}`;
}
